import { ALLOWED_INTERVALS, INTERVAL_LABELS, type Interval, type Timeframe } from "@/lib/types";
import { cn } from "@/lib/utils";

/** Candle-resolution buttons. Only intervals valid for the current period are shown. */
export function IntervalTabs({
  timeframe,
  value,
  onChange,
}: {
  timeframe: Timeframe;
  value: Interval;
  onChange: (i: Interval) => void;
}) {
  const allowed = ALLOWED_INTERVALS[timeframe];
  return (
    <div className="inline-flex flex-wrap gap-1 rounded-lg bg-muted p-1">
      {allowed.map((i) => (
        <button
          key={i}
          onClick={() => onChange(i)}
          className={cn(
            "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
            value === i ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {INTERVAL_LABELS[i]}
        </button>
      ))}
    </div>
  );
}
